export default __webpack_public_path__ + "static/media/addition-achivment-icon.150f8192.svg";